<template>
  <div v-if="renderReady">
    <label class="label">{{ getTitle }}</label>
    <div class="row">
      <div class="col-md-12">
        <strong>{{ displayName || 'Nie wybrano' }}</strong>
        <button v-if="model.$model" class="btn btn-xs btn-outline-danger float-right" @click="unselect">Odznacz</button>
        <button class="btn btn-xs btn-outline-primary float-right" @click="openModal">Wybierz</button>
      </div>
    </div>
    <b-modal
      v-if="showModal"
      title="Struktura"
      v-model="showModal"
      ok-title="Zapisz"
      cancel-title="Anuluj"
      ok-variant="outline-primary"
      cancel-variant="outline-secondary"
      @ok.prevent="selectTreeStruct"
      @hidden="$emit('cancel')"
    >
      <v-jstree :data="items" show-checkbox whole-row @item-click="itemClick"></v-jstree>
    </b-modal>
  </div>
</template>

<script>
import VJstree from 'vue-jstree';
import modelMixin from '@/mixins/modelMixin';
import WError from './error.vue';

import { LogicalStructureResource } from '@/resources/logicalStructure.resource';
import treeService from '@/services/tree.service';

export default {
  components: { WError, VJstree },
  mixins: [modelMixin],
  props: {},
  data() {
    return {
      showModal: false,
      selectedItem: null,
      displayName: '',
      items: []
    };
  },
  computed: {},
  methods: {
    async loadSelectedItem() {
      try {
        const selectedItem = await LogicalStructureResource.get(this.model.$model);
        this.$set(this, 'selectedItem', selectedItem);
        this.$set(this, 'displayName', selectedItem.name);
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: 'Nie udało się pobrać informacji o wybranym węźle struktury logicznej' });
      }
    },
    async openModal() {
      await this.loadData();
      this.showModal = true;
    },
    async loadData() {
      if (this.model.$model) {
        await this.loadSelectedItem();
      }
      await this.loadRootNode();
    },
    async loadRootNode() {
      const logicalStructure = await LogicalStructureResource.fullList();
      const selectedId = this.selectedItem && this.selectedItem.id;
      const treeData = logicalStructure.map(item => treeService.structureNodeToNode(item, selectedId));
      this.$set(this, 'items', treeData);
    },
    itemClick(node) {
      this.$set(this, 'selectedItem', node.model);
    },
    selectTreeStruct() {
      this.model.$model = this.selectedItem.id;
      this.$set(this, 'displayName', this.selectedItem.text);
      this.showModal = false;
    },
    unselect() {
      this.$set(this, 'displayName', undefined);
      this.$set(this, 'selectedItem', undefined);
      this.model.$model = undefined;
    }
  },
  beforeMount() {
    if (this.model.$model) {
      this.loadSelectedItem();
    }
  }
};
</script>

<style></style>
